














































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { CardProviderCapability, DebitCardManagerModalViewState, DebitCardRecord, CardStatus } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {}
})
export default class ManageCardForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    themeStore = useThemeStore();
    DebitCardManagerModalViewState = DebitCardManagerModalViewState;
    selected: null|DebitCardManagerModalViewState = null;

    get managementCapability (): CardProviderCapability {
        return this.debitCardManagementStore.cardProviderOptions.capability;
    }

    get focusedCard (): DebitCardRecord {
        return this.debitCardManagementStore.focusedDebitCard;
    }

    get submitDisabled () {
        return this.selected === null;
    }

    get deactivateDisabled () {
        return this.focusedCard.cardStatus !== CardStatus.Active && this.focusedCard.cardStatus !== CardStatus.Suspended;
    }

    get canCreateOrUpdatePin () {
        return (this.managementCapability.canInitializePin && (! this.focusedCard.isPinSet)) ||
         (this.managementCapability.canUpdatePin && this.focusedCard.isPinSet);
    }

    get pinChangeDisabled () {
        return this.focusedCard.cardStatus === CardStatus.ReplacementRequested ||
          this.focusedCard.cardStatus === CardStatus.LostOrDamaged ||
          this.focusedCard.cardStatus === CardStatus.FraudOrStolen ||
          this.focusedCard.cardStatus === CardStatus.Fraud ||
          this.focusedCard.cardStatus === CardStatus.Stolen ||
          this.focusedCard.cardStatus === CardStatus.Closed ||
          this.focusedCard.cardStatus === CardStatus.Error ||
          this.focusedCard.cardStatus === CardStatus.Suspended;
    }

    onSubmitChanges (e: Event) {
        e.preventDefault();
        this.debitCardManagementStore.setModalState(this.selected);
    }
}
